import React from "react";

const formatDate = (dateStr: string | null) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

const BookingsTableComponent = ({ allUser }: any) => {

  return (
    <>
      <div className="overflow-x-auto">
      <table className="w-full text-sm text-left h-40 mb-9 min-w-[1200px]">
        <thead className="text-xs font-Roboto font-normal text-lightgray">
          <tr>
            <th scope="col" className="p-2">
              <div className="flex items-center"></div>
            </th>
            <th scope="col" className="p-2">BookingId</th>
            <th scope="col" className="p-2">EXT Booking Ref</th>
            <th scope="col" className="p-2">Name</th>
            <th scope="col" className="p-2">Email</th>
            <th scope="col" className="p-2">Phone No.</th>
            <th scope="col" className="p-2">Tour</th>
            <th scope="col" className="p-2">Total Paid</th>
            <th scope="col" className="p-2">Redeem Code</th>
            <th scope="col" className="p-2">Redeems Left</th>
            <th scope="col" className="p-2">Participants</th>
            <th scope="col" className="p-2">Language</th>
            <th scope="col" className="p-2">Booking Date</th>
            <th scope="col" className="p-2">Created</th>
            <th scope="col" className="p-2">Notification</th>
            <th scope="col" className="p-2">Status</th>
          </tr>
        </thead>
        <tbody>
          {allUser &&
            allUser?.map((elm: any, index: any) => {
              const isCancelled = elm?.status === 0;
              const cancellationCount = elm?.cancellationCount || 0;
              const isRepeatCanceller = cancellationCount >= 2;
              return (
              <tr
                key={index}
                className={`border-b border-aqua ${isCancelled ? "bg-red-50" : "bg-white"}`}
              >
                <td className="w-4 p-2">
                  <div className="flex items-center"></div>
                </td>
                <td className="p-2">{elm.bookingId}</td>
                <td className="p-2 text-xs">{elm?.bokunExternalRef || elm?.externalBookingRef || "—"}</td>
                <td className="p-2">
                  {elm.name}
                  {isRepeatCanceller && (
                    <span className="ml-1 px-1.5 py-0.5 text-[10px] font-bold bg-red-600 text-white rounded" title={`${cancellationCount} cancelled bookings from this email`}>
                      {cancellationCount}x CANCELLED
                    </span>
                  )}
                </td>
                <td className="p-2">{elm?.email}</td>
                <td className="p-2">{elm?.phoneNumber}</td>
                <td className="p-2">{elm?.productTitle}</td>
                <td className="p-2 whitespace-nowrap">
                  {elm?.totalPaid != null
                    ? `${elm?.currency || "USD"} ${Number(elm.totalPaid).toFixed(2)}`
                    : "—"}
                </td>
                <td className="p-2 font-mono font-bold text-aqua">{elm?.redeemCodeData?.redeemCode}</td>
                <td className="p-2">{elm?.redeemCodeData?.redeemCounter}</td>
                <td className="p-2">{elm?.totalParticipants}</td>
                <td className="p-2 capitalize">{elm?.bookingLanguage || "—"}</td>
                <td className="p-2 whitespace-nowrap">{formatDate(elm?.bookingDate)}</td>
                <td className="p-2 whitespace-nowrap">{formatDate(elm?.createdAt)}</td>
                <td className="p-2">{elm?.notification || "—"}</td>
                <td className="p-2">
                  {isCancelled ? (
                    <span className="px-2 py-1 text-xs font-semibold bg-red-100 text-red-700 rounded-full">Cancelled</span>
                  ) : (
                    <span className="px-2 py-1 text-xs font-semibold bg-green-100 text-green-700 rounded-full">Active</span>
                  )}
                </td>
              </tr>
              );
            })}
        </tbody>
      </table>
      </div>
    </>
  );
};

export default BookingsTableComponent;
